<template>
  <HrmisCrudModule v-bind="config" />
</template>

<script>
import HrmisCrudModule from "./HrmisCrudModule.vue";

export default {
  name: "ModuleBoardDecisions",
  components: { HrmisCrudModule },
  data() {
    return {
      config: {
        title: "Board decision tracking",
        subtitle: "PSC / board resolutions and implementation status",
        icon: "⚖️",
        listFunction: "getBoardDecisionList",
        saveFunction: "saveBoardDecision",
        permissionViewCodes: ["BOARD_DECISION_VIEW", "BOARD_DECISION_MANAGE"],
        permissionManageCodes: ["BOARD_DECISION_MANAGE"],
        loadDepartments: true,
        columns: [
          { key: "decision_ref", label: "Ref" },
          { key: "board_type", label: "Board" },
          { key: "subject", label: "Subject", truncate: 40 },
          { key: "decision_date", label: "Date" },
          { key: "implementation_status", label: "Implementation" }
        ],
        fields: [
          { key: "decision_ref", label: "Decision reference", type: "text" },
          {
            key: "board_type",
            label: "Board type",
            type: "select",
            options: ["PSB", "County", "Other"],
            default: "PSB"
          },
          { key: "subject", label: "Subject", type: "text", required: true },
          { key: "summary", label: "Summary", type: "textarea" },
          { key: "decision_date", label: "Decision date", type: "date" },
          {
            key: "implementation_status",
            label: "Implementation status",
            type: "select",
            options: ["Pending", "In Progress", "Completed", "Overdue"],
            default: "Pending"
          },
          { key: "department_id", label: "Responsible department (county)", type: "department" }
        ]
      }
    };
  }
};
</script>
